export const helplistTitle = {
  acctNoSfx: 'Account No. Suffix',
  branch: 'Branch',
  busCls: 'Bussiness Class',
  curr: 'Currency',
  cty: 'Country',
  ctyAgt: 'Country Agent',
  ctyCed: 'Country Cedant',
  ctyRi: 'Country RI',
  ctyRisk: 'Country Risk',
  dept: 'Department',
  fund: 'Fund',
  glanCode: 'GL Analysis Code',
  glAcctNo: 'GL Account No.',
  glAcctNoDebtCtrl: 'GL Account No. for Debtors Control',
  glAcctNoDiffEx: 'GL Account No. for Different Exchange - Realised',
  glAcctNoRevalue: 'GL Account No. for Different Exchange - Revalue',
  glAcctNoWoff: 'GL Account No. for Write-Off',
  glAcctNoInGst: 'GL Account No. for Input GST',
  glAcctNoOutGst: 'GL Account No. for Output GST',
  gstKeyBrn: 'GST Key for Branch',
  gstStat: 'GST Status',
  polMaster: 'Policy Master',
  polType: 'Policy Type',
  polTypeCls: 'Permitted Business Class Per Policy Type',
  revalueAcct: 'Revalue Account No.',
  regn1: 'Region 1',
  parentAcct: 'Parent Account No.',
  statsVal: 'Statistics Value',
  stmtLnGL: 'Statement Line GL',
  busAnGL: 'Business Analysis GL',
  cedAreaGL: 'Cedant Area GL',
  riAreaGL: 'RI Area GL',
  riskAreaGL: 'Risk Area GL'
}
